import { render, staticRenderFns } from "./make-your-ideal-classroom.vue?vue&type=template&id=1e47985a&"
import script from "./make-your-ideal-classroom.vue?vue&type=script&lang=js&"
export * from "./make-your-ideal-classroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports